module.exports = __webpack_public_path__ + "static/media/PowerButtonClicked.f43c9404.svg";